<template>
    <v-container class="pa-2" fluid grid-list-sm >
        <div v-if="needInit">{{initData()}}</div>
        <div v-if="getLanguageChanged">{{refresh()}}</div>
        
        <v-card class="shadow-none" v-if="$store.getters.getLanguageList">     
            <div v-if="getShowHelpEvent">{{showHelp()}}</div>
            <div v-if="getShowAnswerEvent">{{showAnswer()}}</div>
            <div v-if="getCheckAnswerEvent">{{checkAnswer()}}</div>
            <div v-if="needInit">{{initData()}}</div> 
            <div v-if="myContent">
                <div v-html="myContent.content"></div>
                    <div v-for="(item, index) in myContent.answer_list" :key="index" >
                        <v-checkbox v-model="myAnswers" :label="item.answer" :value="index" :color="(getStyle(index)).color" @change="resetEvaluatedData"></v-checkbox>
                        <p v-if="myAnswers.indexOf(index) > -1 && showFeedback" v-bind:style="getStyle(index)">{{item.feedback}}</p>
                    </div>             
                    <p v-if="showFeedback">result: {{questionResult}}</p>   
            </div>
        </v-card>

        <v-card class="shadow-none" v-if="showMyHelp">
            <div v-html="myContent.help">
            </div>
            <v-btn @click="showMyHelp = false">Hide Help</v-btn>
        </v-card>
    </v-container>
</template>

<script>
import {mapGetters} from 'vuex'

export default {   
    data() {
        return {
                myContent:  {
                    content: 'loading...',
                    help: 'loading...',
                    answer_list : [{
                        answer : 'loading...',
                        feedback: 'loading...'
                    }]
                },
                myAnswers : [],
                myGlobals: null,
                feedback: null,
                showMyHelp: false,
                needInit : false,
                styleObject: {
                    color: 'black',
                },
                showFeedback: false,
                questionResult: 0

        }
    },
    computed: 
        mapGetters([
                    'getShowHelpEvent',
                    'getShowAnswerEvent',
                    'getCheckAnswerEvent',
                    'getLanguagePrimary',
                    'getLanguageChanged'
                    ])
    ,    
    props: { 
        dcontent: Object
    },
    methods: {
        initData() {
            this.needInit = false         
            this.$store.commit('setFeedback', null)   
            this.myContent = JSON.parse(this.dcontent.data.content)
            this.myGlobals = JSON.parse(this.dcontent.data.globals)

            // shuffle
            for(let i=0; i < this.myContent.answer_list.length; i++) {
                const rand = Math.floor(Math.random() * this.myContent.answer_list.length);
                [this.myContent.answer_list[i], this.myContent.answer_list[rand]] = [this.myContent.answer_list[rand], this.myContent.answer_list[i]];
                [this.myGlobals.ratings[i], this.myGlobals.ratings[rand]] = [this.myGlobals.ratings[rand], this.myGlobals.ratings[i]];
            }                        
        },
        checkAnswer() {
            this.$store.commit('setCheckAnswerEvent', false)
            this.questionResult = 0
            for(let i = 0; i < this.myContent.answer_list.length; i++) {
                if (this.myAnswers.indexOf(i) > -1)  this.questionResult += this.myGlobals.ratings[i]
            }
            this.showFeedback = true
            this.questionResult = Math.floor(this.questionResult + 0.5)
        },
        showAnswer() { 
            this.$store.commit('setShowAnswerEvent', false)
            this.myAnswers = []
            for(var i = 0; i < this.myGlobals.ratings.length; i++) {
                if (this.myGlobals.ratings[i] > 0) {
                    this.myAnswers.push(i)
                }
            }       
            this.checkAnswer()     
        },
        getStyle(index) {
            if (!this.showFeedback) return { color: "black"}
            if (this.myAnswers.indexOf(index) == -1) return { color: "black"}
            if (this.myGlobals.ratings[index] > 0) return { color: "green"}
            return { color: "red"}
        },
        showHelp() {
            this.$store.commit('setShowHelpEvent', false)
            this.showMyHelp = true
        },
        refresh() {
            this.$store.commit('setLanguageChanged',false)
            this.initData()
        },
        resetEvaluatedData() {
            this.showFeedback = false
            this.styleObject.color = 'black'
        }
    },
    mounted() {
        this.needInit = true
    }
}
</script>

<style>
</style>